module.exports = (__webpack_require__(60979))(1972);